import { FeePresetsSettings } from '@/pages/settings/FeePresetsSettings.js';

export function FeePresetsSettingsPage() {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
      <h2 className="mb-4 text-xl font-bold text-slate-950">Fee Presets</h2>
      <FeePresetsSettings />
    </div>
  );
}
